import { render, staticRenderFns } from "./NearbyCragsCarousel.vue?vue&type=template&id=27048126"
import script from "./NearbyCragsCarousel.vue?vue&type=script&lang=js"
export * from "./NearbyCragsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports